<ion-header>
  <ion-toolbar>
    <ion-title>
      @if(editModal) { 
        {{ 'Update Player' | translate }} 
      } @else { 
        {{ 'Add Player' | translate }} 
      }
    </ion-title>
    <ion-buttons slot="end">
      <ion-button color="dark" fill="clear" (click)="close()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <form [formGroup]="form">
    <ion-list>
      <!-- Profile Image -->
      <ion-item>
        <div class="upload-image">
          <app-upload-image
            (imageSelected)="imageSelected($event)"
            [userImage]="user?.profile_image?.original || user?.profile_image"
          ></app-upload-image>
        </div>
      </ion-item>

      <!-- First name -->
      <ion-item>
        <ion-input
          class="ion-text-right"
          autocapitalize="true"
          formControlName="first_name"
          name="First Name"
          placeholder="{{'First name' | translate}}"
        >
          <div slot="label">
            {{'First name' | translate}} <ion-text color="danger">*</ion-text>
          </div>
        </ion-input>
      </ion-item>

      <!-- Last name -->
      <ion-item>
        <ion-input
          class="ion-text-right"
          autocapitalize="true"
          formControlName="last_name"
          name="Last Name"
          placeholder="{{'Last name' | translate}}"
        >
          <div slot="label">
            {{'Last name' | translate}} <ion-text color="danger">*</ion-text>
          </div>
        </ion-input>
      </ion-item>

      <ion-item>
        <ion-select
          formControlName="sex"
          interface="popover"
          placeholder="{{'Select gender' | translate}}"
        >
          <div slot="label">{{'Gender' | translate}} <ion-text color="danger">*</ion-text></div>
          <ion-select-option value="M">{{ 'Male' | translate }}</ion-select-option>
          <ion-select-option value="F">{{ 'Female' | translate }}</ion-select-option>
        </ion-select>
      </ion-item>
      
      @if(editModal){
        <ion-item>
          <ion-input
            class="ion-text-right"
            autocapitalize="true"
            formControlName="height"
            name="Height"
            placeholder="{{'Height' | translate}}"
          >
            <div slot="label">
              {{'Height' | translate}}
            </div>
          </ion-input>
        </ion-item>
        <ion-item>
          <ion-input
            class="ion-text-right"
            autocapitalize="true"
            formControlName="age"
            name="Age"
            placeholder="{{'Age' | translate}}"
          >
            <div slot="label">
              {{'Age' | translate}}
            </div>
          </ion-input>
        </ion-item>
        <ion-item>
            <ion-input
              class="ion-text-right"
              autocapitalize="true"
              formControlName="hometown"
              name="Hometown"
              placeholder="{{'Hometown' | translate}}"
            >
            <div slot="label">{{'Hometown' | translate}}</div>
            </ion-input>
        </ion-item>
        <!-- <ion-item>
            <div class="bannerimage">
              <div>Banner image for web</div>

            <div class="upload-image ion-text-right">
              <app-upload-image
                (imageSelected)="setBannerImageWeb($event)"
                [userImage]="user?.banner_image_web"
                [cropImage]="false"
              ></app-upload-image>
            </div>
          </div>
        </ion-item> -->
        <!-- <ion-item>
          <div class="bannerimage">
            <div>Banner image for mobile</div>

          <div class="upload-image ion-text-right">
            <app-upload-image
              (imageSelected)="setBannerImageMobile($event)"
              [userImage]="user?.banner_image_mobile"
                [cropImage]="false"
            ></app-upload-image>
          </div>
        </div>
        </ion-item>  -->
        <ion-item>
            <div class="bannerimage">
              <div>{{'Action shot Image' | translate}}</div>

            <div class="upload-image ion-text-right">
              <app-upload-image
                (imageSelected)="setActionShotImage($event)"
                [userImage]="user?.action_shot_image"
                [cropImage]="false"
                [disableImageResize]="true"
              ></app-upload-image>
            </div>
          </div>
        </ion-item>
        <ion-item-divider>
            <ion-label class="ion-text-center" style="font-weight: bold;">{{'Social Media Links' | translate}}</ion-label>
        </ion-item-divider>
        <ion-item>
          <div class="social-item">
            <label class="social-label">{{'Facebook' | translate}}</label>
            <ion-input
              class="ion-text-right"
              type="url"
              formControlName="facebook"
              placeholder="https://facebook.com/username">
            </ion-input>
          </div>
        </ion-item>
        <ion-item>
          <div class="social-item">
            <label class="social-label">{{'Instagram' | translate}}</label>
            <ion-input class="ion-text-right" type="url" formControlName="instagram" placeholder="https://instagram.com/username"></ion-input>
          </div>
        </ion-item>
        <ion-item>
          <div class="social-item">
            <label class="social-label">{{'X' | translate}}</label>
            <ion-input class="ion-text-right" type="url" formControlName="x" placeholder="https://x.com/username"></ion-input>
          </div>
        </ion-item>
        <ion-item>
          <div class="social-item">
            <label class="social-label">{{'TikTok' | translate}}</label>
            <ion-input class="ion-text-right" type="url" formControlName="tiktok" placeholder="https://tiktok.com/@username"></ion-input>
          </div>
        </ion-item>
        <ion-item>
          <div class="social-item">
            <label class="social-label">{{'YouTube' | translate}}</label>
            <ion-input class="ion-text-right" type="url" formControlName="youtube" placeholder="https://youtube.com/@username"></ion-input>
          </div>
        </ion-item>
        <ion-item>
          <div class="social-item">
            <label class="social-link-title social-label" position="floating">{{'LinkedIn' | translate}}</label>
            <ion-input class="ion-text-right" type="url" formControlName="linkedin" placeholder="https://linkedin.com/in/username"></ion-input>
          </div>
        </ion-item> 
        <ion-item>
          <div class="social-item-bio">
            <label class="social-label">{{'Bio' | translate}}</label>
            <ion-textarea
              formControlName="about"
              name="Bio"
              placeholder="{{'Enter your bio...' | translate}}"
              autoGrow="true"
            >
            </ion-textarea>
          </div>
        </ion-item> 
    }
    </ion-list>
  </form>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <ion-button
      color="primary m-250"
      (click)="submit()"
      expand="block"
      translate
    >
      @if (!submittingForm) { 
        @if (!isEdit) { 
          {{ 'Save' | translate }} 
        } @else { 
          {{ 'Update' | translate }} 
        } 
      } @else {
        <ion-spinner name="crescent"></ion-spinner>
      }
    </ion-button>
  </ion-toolbar>
</ion-footer>
